import React from "react";

export const CompanyRegistrationContext = React.createContext({
    parent: null,
    companyService: null,
});